export enum IconButtonTheme {
  LIGHT = "light",
  LIGHT_DESTRUCTIVE = "light-destructive",
  DARK = "dark",
  GREY = "grey"
}

export enum IconButtonSize {
  DEFAULT = "default",
  SMALL = "small",
}